import React, { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    Link, Stack, Paper, TextField, Box, Grid, Typography, Card, TableCell, TableContainer,
    Table, InputAdornment, TableHead, Button, IconButton, FormControl, CardContent, DialogContent, DialogTitle, Dialog,
    InputLabel, TableRow, TableBody, Snackbar, CircularProgress, AccordionDetails, MenuItem, Checkbox, Autocomplete, Tooltip
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput, ERPinputNo } from '../../reusableComponent/ErpTextField';
import { StyledTableCell, StyledTableRow } from '../../reusableComponent/StyledTable';
import { addPurchaseInvoice, editDeletePurchaseInvoice, getCNSList, getItemList, } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import styles from '.././../../styles.module.css';

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px', // Set the desired font size
    },
});

function PurchaseReturnAdd(props) {
    const editData = props.details;
    const dispatch = useDispatch();
    const classes = useStyles();
    const { handleSubmit } = useForm();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let navigate = useNavigate();
    const location = useLocation();
    const editid = editData && editData.id;
    const currentDate = new Date().toISOString().substring(0, 10);
    const [supplierName, setSupplierName] = useState(editData ? editData.supplierName : null);
    const supplierList = useSelector(state => state.CNS.CNS)
    const itemList = useSelector(state => state.item.item)
    const handleChangeSupplier = (event, newValue) => {
        setSupplierName(newValue)
    }
    const handleChangeItemDescription = (event, newValue) => {
        setItemDescription(newValue)
        childObj['itemId'] = newValue ? newValue.id : null
        childObj['itemDescription'] = newValue ? newValue.itemName : null
        childObj['itemCode'] = newValue ? newValue.itemCode : null
        childObj['hsnCode'] = newValue ? newValue.hsnCode : null
        childObj['rate'] = newValue ? newValue.rate : null
        childObj['unit'] = newValue ? newValue.unitName : null
        childObj['gst'] = newValue ? newValue.gst : null

    }

    const [selectItemCode, setSelectItemCode] = useState([]);
    const [isSet, setIsSet] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);
    const [debitNoteDate, setDebitNoteDate] = React.useState(editData ? dayjs(editData.debitNoteDate) : dayjs(new Date()));
    const [againstInvoiceDate, setAgainstInvoiceDate] = React.useState(editData ? dayjs(editData.againstInvoiceDate) : dayjs(new Date()));
    const [orderDate, setOrderDate] = React.useState(editData ? dayjs(editData.orderDate) : dayjs(new Date()));
    const [basicTotal, setBasicTotal] = useState(editData ? editData.basicTotal : 0);
    const [gstTotal, setGstTotal] = useState(editData ? editData.gstTotal : 0);
    const [cgstTotal, setCgstTotal] = useState(editData ? editData.cgstTotal : 0);
    const [sgstTotal, setSgstTotal] = useState(editData ? editData.sgstTotal : 0);
    const [igstTotal, setIgstTotal] = useState(editData ? editData.igstTotal : 0);
    const [total, setTotal] = useState(editData ? editData.total : 0);
    const [itemDescription, setItemDescription] = useState(null);

    const date_ob = new Date();
    const hours = date_ob.getHours();
    const minutes = date_ob.getMinutes();
    const seconds = date_ob.getSeconds();
    const milliseconds = date_ob.getMilliseconds();
    const currentTime = hours + ":" + minutes + ":" + seconds + ":" + milliseconds;

    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISODateTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
    const [openChild, setOpenChild] = React.useState(false);
    const [openChidOption, setOpenChildOption] = useState('');

    const [data, setData] = useState({
        id: editid,
        otherReference: editData ? editData.otherReference : '',
        remarks: editData ? editData.remarks : '',
        basicTotal: editData ? editData.basicTotal : 0,
        gstTotal: editData ? editData.gstTotal : 0,
        cgstTotal: editData ? editData.cgstTotal : 0,
        total: editData ? editData.total : 0,
    });

    console.log("Array child ", JSON.parse(editData.childRows))
    const [inputFields, setInputFields] = useState(
        editData ? JSON.parse(editData.childRows) :
            [{
                id: uuidv4(),
                itemId: null,
                itemName: '',
                itemCode: '',
                itemDescription: '',
                hsnCode: '',
                quantity: '',
                unit: '',
                rate: '',
                gst: '',
                cgst: '',
                sgst: '',
                igst: '',
                gstAmount: '',
                cgstAmount: '',
                sgstAmount: '',
                igstAmount: '',
                basicAmount: '',
                amount: '',
                grnStatus: 0,
            },
            ]);


    const handleRemoveFields = (id) => {
        const values = [...inputFields];
        values.splice(
            values.findIndex((value) => value.id === id),
            1
        );
        setInputFields(values);

        const reducer = (previousValue, currentValue) => previousValue + currentValue;

        const totalCount = values && values.map(value => value.basicAmount && value.basicAmount ? parseFloat(value.basicAmount) : 0).reduce(reducer);
        const gstTotalCount = values && values.map(value => value.gstAmount && value.gstAmount ? parseFloat(value.gstAmount) : 0).reduce(reducer);
        const cgstTotalCount = values && values.map(value => value.cgstAmount && value.cgstAmount ? parseFloat(value.cgstAmount) : 0).reduce(reducer);
        const sgstTotalCount = values && values.map(value => value.sgstAmount && value.sgstAmount ? parseFloat(value.sgstAmount) : 0).reduce(reducer);
        const igstTotalCount = values && values.map(value => value.igstAmount && value.igstAmount ? parseFloat(value.igstAmount) : 0).reduce(reducer);
        const amountTotalCount = values && values.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);

        setBasicTotal(totalCount);
        setGstTotal(gstTotalCount);
        setCgstTotal(cgstTotalCount);
        setSgstTotal(sgstTotalCount);
        setIgstTotal(igstTotalCount);
        setTotal(amountTotalCount);
    };

    const handleChangeDebitNoteDate = (newValue) => {
        setDebitNoteDate(newValue);
    };

    const handleChangeAgainstInvoiceDate = (newValue) => {
        setAgainstInvoiceDate(newValue);
    };



    const handleChange = ({ target }) => {
        const value = target.value;
        setData({
            ...data,
            [target.name]: value,
        });
        data[target.name] = target.value;
        setIsSet(isSet ? false : true)

    }

    const supplierGetData = () => {
        dispatch(getCNSList({financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: 'Supplier' }));
    }
    const itemGetData = () => {
        dispatch(getItemList({ companyId: userInfo.companyId }));
    }


    const handleClose = (event, reason) => {
        if (editData) {
            if (reason !== 'backdropClick') {
                setOpen(false);
            }
        } else {
            setData('')
            setInputFields([{}])
            setSupplierName('')

            if (reason !== 'backdropClick') {
                setOpen(false);
            }
        }

    };

    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const loading = open && options.length === 0;

    React.useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.purchaseInvoice.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
            setSuccessMessage(responseMessage);

        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setShouldShowMsg(false);
                setSuccessMessage(responseMessage);
                setOpen(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
            }
        }
    }, [shouldShowMsg, responseMessage,]);

    const clearInputFields = () => {
        setSupplierName(null);
        setBasicTotal('');
        setGstTotal('');
        setTotal('');
        setCgstTotal('');
        setSgstTotal('');
        setIgstTotal('');
        setData({
            orderNo: '',
            invoiceNo: '',
            vehicleNo: '',
            transporter: '',
        });
        // setInvoiceDate(dayjs(new Date()));
        setInputFields([
            {
                id: uuidv4(),
                itemCode: '',
                itemName: '',
                itemId: '',
                quantity: 0,
                rate: 0,
                gst: 0,
                basicAmount: 0,
                gstAmount: 0,
                amount: 0,
            },
        ]);
    };

    const onSubmit = (event) => {

        let purchaseEntryData = {
            ...data,
            againstInvoiceDate: againstInvoiceDate,
            childRows: inputFields,
            basicTotal: basicTotal,
            gstTotal: gstTotal,
            cgstTotal: cgstTotal,
            sgstTotal: sgstTotal,
            igstTotal: igstTotal,
            total: total,
            pendingAmount: total,
            companyId: userInfo.companyId,
            supplierName: supplierName,
            currentTime: currentTime,
            createdBy: editData ? editData.createdBy : userInfo.userId,
            createdAt: editData ? editData.createdAt : localISODateTime,
            updatedBy: editData ? userInfo.userId : null,
            updatedAt: editData ? localISODateTime : '',
            changedUpdatedValue: 'edit'
        }

        if (editData) {
            dispatch(editDeletePurchaseInvoice(purchaseEntryData));
        } else {
            dispatch(addPurchaseInvoice(purchaseEntryData));
        }
        clearInputFields();
    }

    useEffect(() => {
        supplierGetData()
        itemGetData()

        if (editData.id) {
            setSupplierName({
                CNS_Name: editData.CNS_Name,
                id: editData.supplierName,
                emailId: editData.emailId,
                gstn: editData.gstn,
                address: editData.address,
                pinCode: editData.pinCode,
                state: editData.state,
            })
            setItemDescription({
                itemName: editData.itemName,
                id: editData.itemDescription,
                itemType: editData.itemType,
                itemCode: editData.itemCode,
                itemDescriptionDetails: editData.itemDescription,
                binNo: editData.binNo,
                unitName: editData.unitName,
                rate: editData.rate,
                gst: editData.gst,
                hsnCode: editData.hsnCode,
            })
        }

    }, []);

    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };

    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );


    //  ====CHILD popup=====


    const handleOk = (filledData) => {

        setInputFields([
            ...inputFields,
            {
                id: uuidv4(),
                itemDescription: filledData.itemDescription,
                hsnCode: filledData.hsnCode,
                unit: filledData.unit,
                itemCode: filledData.itemCode,
                itemId: filledData.itemId,
                itemName: filledData.itemName,
                quantity: filledData.quantity,
                rate: filledData.rate,
                gst: filledData.gst,
                amount: filledData.amount,
                cgst: filledData.cgst,
                sgst: filledData.sgst,
                igst: filledData.igst,
                gstAmount: filledData.gstAmount,
                cgstAmount: filledData.cgstAmount,
                sgstAmount: filledData.sgstAmount,
                igstAmount: filledData.igstAmount,
                basicAmount: filledData.basicAmount,
            }
        ]);
        setOpenChild(false);
        handleCalculation(filledData.amount)

    }
    const [childObj, setChildObj] = useState({
        itemId: null,
        itemName: '',
        itemCode: '',
        itemDescription: '',
        hsnCode: '',
        quantity: '',
        unit: '',
        rate: '',
        gst: '',
        cgst: '',
        sgst: '',
        igst: '',
        gstAmount: '',
        cgstAmount: '',
        sgstAmount: '',
        igstAmount: '',
        basicAmount: '',
        amount: ''
    })


    const [childDetails, setChildDetails] = useState({});
    const handleChildDetails = (details) => {
        setOpenChild(true);
        setOpenChildOption('ChildDetails')
        setChildDetails(details)
    }

    const handleChildEdit = (details) => {
        setOpenChild(true);
        setOpenChildOption('childEdit')
        setChildObj(details)
        console.log("Details ", details)
    }

    const handleClickOpenChild = () => {
        setOpenChild(true);
        setOpenChildOption('childCreate')
        setChildObj([
            {
                itemDescription: '',
                hsnCode: '',
                quantity: '',
                unit: '',
                rate: '',
                gst: '',
                bill_amount: ''
            }
        ])
        setItemDescription(null)
    };

    const handleCalculation = (rate, qty, gst) => {
        const basicAmt = parseFloat(rate) * parseFloat(qty)
        const gstAmt = (basicAmt * parseFloat(gst)) / 100;
        const totalAmt = basicAmt + gstAmt;
        const cgstPer = (supplierName.state === userInfo.state) ? (parseFloat(gst)) / 2 : 0;
        const sgstPer = (supplierName.state === userInfo.state) ? (parseFloat(gst)) / 2 : 0;
        const igstPer = (supplierName.state === userInfo.state) ? 0 : (parseFloat(gst));
        const cgstAmt = (supplierName.state === userInfo.state) ? (parseFloat(gstAmt)) / 2 : 0;
        const sgstAmt = (supplierName.state === userInfo.state) ? (parseFloat(gstAmt)) / 2 : 0;
        const igstAmt = (supplierName.state === userInfo.state) ? 0 : (parseFloat(gstAmt));

        childObj['basicAmount'] = basicAmt.toFixed(2);
        childObj['gstAmount'] = gstAmt.toFixed(2);
        childObj['amount'] = totalAmt.toFixed(2);
        childObj['cgst'] = cgstPer.toFixed(2);
        childObj['sgst'] = sgstPer.toFixed(2);
        childObj['igst'] = igstPer.toFixed(2);
        childObj['cgstAmount'] = cgstAmt.toFixed(2);
        childObj['sgstAmount'] = sgstAmt.toFixed(2);
        childObj['igstAmount'] = igstAmt.toFixed(2);
        const temp = Object.assign({}, childObj);
        setChildObj(temp);

        const reducer = (previousValue, currentValue) => previousValue + currentValue;

        const totalCount = inputFields && inputFields.map(value => value.basicAmount && value.basicAmount ? parseFloat(value.basicAmount) : 0).reduce(reducer);
        const gstTotalCount = inputFields && inputFields.map(value => value.gstAmount && value.gstAmount ? parseFloat(value.gstAmount) : 0).reduce(reducer);
        const cgstTotalCount = inputFields && inputFields.map(value => value.cgstAmount && value.cgstAmount ? parseFloat(value.cgstAmount) : 0).reduce(reducer);
        const sgstTotalCount = inputFields && inputFields.map(value => value.sgstAmount && value.sgstAmount ? parseFloat(value.sgstAmount) : 0).reduce(reducer);
        const igstTotalCount = inputFields && inputFields.map(value => value.igstAmount && value.igstAmount ? parseFloat(value.igstAmount) : 0).reduce(reducer);
        const amountTotalCount = inputFields && inputFields.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);

        // const totalCount = inputFields && inputFields.map(value => value.amount && value.amount ? parseFloat(value.amount) : 0).reduce(reducer);
        // data['basicTotal'] = (totalCount).toFixed(2);
        // data['gstTotal'] = (gstTotalCount).toFixed(2);
        // data['cgstTotal'] = (cgstTotalCount).toFixed(2);
        // data['sgstTotal'] = (sgstTotalCount).toFixed(2);
        // data['igstTotal'] = (igstTotalCount).toFixed(2);
        // data['total'] = (amountTotalCount).toFixed(2);

        // const temp1 = Object.assign({}, data);
        // setData(temp1);
        setBasicTotal(totalCount).toFixed(2);
        setGstTotal(gstTotalCount).toFixed(2);
        setCgstTotal(cgstTotalCount).toFixed(2);
        setSgstTotal(sgstTotalCount).toFixed(2);
        setIgstTotal(igstTotalCount).toFixed(2);
        setTotal(amountTotalCount).toFixed(2);
    }

    const handleMultipleInput = ({ target }) => {
        const value = target.value;
        setChildObj({
            ...childObj,
            [target.name]: value,
        });
        childObj[target.name] = target.value;

        // ----------------

        if (target.name == 'quantity') {
            handleCalculation(childObj['rate'], target.value, childObj['gst'])
        }
        if (target.name == 'rate') {
            handleCalculation(target.value, childObj['quantity'], childObj['gst'])
        }

        if (target.name == 'gst') {
            handleCalculation(childObj['rate'], childObj['quantity'], target.value)
        }
        const temp = Object.assign({}, childObj);
        setChildObj(temp);
    }
    const handleUpdateOpenChild = (id) => {
        setOpenChild(true)
        const values = [...inputFields];
        values.findIndex((value) => value.id === id)
    }
    const handleCloseChild = (value) => {
        setOpenChild(false);
    };

    return (
        <>
            <div>
                <Paper className='mainContainer' sx={{ boxShadow: 'none' }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Box>
                            <Grid container spacing={0} sx={{ p: 0 }}>
                                <Grid item md={6}>
                                    <Autocomplete sx={{ marginBottom: '10px' }}
                                        fullWidth
                                        classes={{
                                            option: classes.option,
                                        }}
                                        noOptionsText={
                                            <span className={classes.noOptionsLabel}>No options</span>
                                        }
                                        options={supplierList}
                                        value={supplierName}
                                        onChange={handleChangeSupplier}
                                        getOptionLabel={(option) => option.CNS_Name}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderInput={(params) => <ERPinput required
                                            placeholder="Please Select Supplier"
                                            sx={{
                                                width: { sm: 350, md: 350 },
                                                "& .MuiInputBase-root": {
                                                    height: 25,
                                                    fontSize: 12,
                                                }
                                            }} {...params} />}
                                    />
                                    {supplierName &&
                                        <Card sx={{ maxWidth: 350, backgroundColor: '#f0efed', }}>
                                            <CardContent sx={{ padding: 1 }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '15px' }}> {supplierName.CNS_Name}</Typography>
                                                <Typography sx={{ fontSize: '11px', }}><Icon icon="arcticons:gstrings" width="14" height="12" style={{ marginRight: '7px' }} /> {supplierName.gstn} </Typography>
                                                <Typography sx={{ fontSize: '11px' }}> <Icon icon="fa6-regular:address-card" width="12" height="12" style={{ marginRight: '8px' }} /> {supplierName.address}</Typography>
                                                <Typography sx={{ fontSize: '11px' }}> {supplierName.state + ","} {supplierName.pinCode} </Typography>
                                            </CardContent>
                                        </Card>
                                    }
                                </Grid>
                                <Grid item md={6}>
                                    <Box >
                                        <Grid container spacing={1} >
                                            {editData.id ?
                                                <>
                                                    <Grid item xs={2}>
                                                        <Typography className={`${styles.erp_lable}`}>Debit Note No</Typography>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <ERPinput
                                                            InputProps={{
                                                                readOnly: true,
                                                            }}
                                                            disabled={true}
                                                            size='small'
                                                            fullWidth
                                                            name="debitNoteNo"
                                                            type="text"
                                                            onChange={handleChange}
                                                            value={editData.debitNoteNo}
                                                        />
                                                    </Grid>
                                                </>
                                                :
                                                <Grid item xs={6}></Grid>
                                            }
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}> Date</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="debitNoteDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={debitNoteDate}
                                                        onChange={handleChangeDebitNoteDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'
                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>Against Invoice No</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    name="againstInvoiceNo"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.againstInvoiceNo)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>Invoice Date</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DesktopDatePicker
                                                        name="againstInvoiceDate"
                                                        inputFormat="DD/MM/YYYY"
                                                        value={againstInvoiceDate}
                                                        onChange={handleChangeAgainstInvoiceDate}
                                                        renderInput={(params) => <ERPinput  {...params} size='small'

                                                            fullWidth />}
                                                    />
                                                </LocalizationProvider>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography className={`${styles.erp_lable}`}>Other Reference</Typography>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <ERPinput
                                                    size='small'
                                                    fullWidth
                                                    name="otherReference"
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={(data.otherReference)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>

                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        <br />
                        <TableContainer component={Paper} sx={{ overflowY: 'auto', height: 140 }}>
                            <Table sx={{ minWidth: 800 }} size='small' stickyHeader >
                                <TableHead >
                                    <StyledTableRow>
                                        <StyledTableCell align="left" className={`${styles.table_head}`} style={{ fontWeight: "bold" }}>
                                            Item Description
                                        </StyledTableCell>
                                        <StyledTableCell align="left" className={`${styles.table_head}`}>HSN Code</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Quantity</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Unit</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Rate</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>GST %</StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.table_head}`}>Amount</StyledTableCell>
                                        {/* <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ display: 'none' }}>CGST %</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ display: 'none' }}>SGST %</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ display: 'none' }}>IGST %</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ display: 'none' }}>Cgst Amount</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ display: 'none' }}>sgst Amount</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.table_head}`} sx={{ display: 'none' }}>igst Amount</StyledTableCell> */}
                                        <StyledTableCell align="center" className={`${styles.table_head}`} >Action
                                            <Tooltip title="Add Items">
                                                <IconButton sx={{ padding: '0px' }}>
                                                    <Icon icon="material-symbols:add-box-rounded" onClick={handleClickOpenChild} width="18" height="18" color="#00527c" style={{ marginLeft: '12px' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {inputFields && inputFields.map((row, index) => (
                                        <>
                                            <StyledTableRow key={row.id} >
                                                <StyledTableCell className={`${styles.list_table_body}`} align="left" onClick={() => handleChildDetails(row)}>
                                                    {row.itemName + ' (' + row.itemCode + ')'}
                                                </StyledTableCell>
                                                <StyledTableCell className={`${styles.list_table_body}`} align="left" onClick={() => handleChildDetails(row)}>
                                                    {row.hsnCode}
                                                </StyledTableCell>
                                                <StyledTableCell className={`${styles.list_table_body}`} align="right" onClick={() => handleChildDetails(row)}>
                                                    {row.quantity}
                                                </StyledTableCell>
                                                <StyledTableCell className={`${styles.list_table_body}`} align="right" onClick={() => handleChildDetails(row)}>
                                                    {row.unit}
                                                </StyledTableCell>
                                                <StyledTableCell className={`${styles.list_table_body}`} align="right" onClick={() => handleChildDetails(row)}>
                                                    {row.rate}
                                                </StyledTableCell>
                                                <StyledTableCell className={`${styles.list_table_body}`} align="right" onClick={() => handleChildDetails(row)}>
                                                    {row.gst}
                                                </StyledTableCell>
                                                <StyledTableCell className={`${styles.list_table_body}`} align="right" onClick={() => handleChildDetails(row)}>
                                                    {parseFloat(row.amount).toFixed(2)}
                                                </StyledTableCell>
                                                <StyledTableCell align="center" className={`${styles.list_table_body}`}>
                                                    <EditIcon onClick={() => handleChildEdit(row)} sx={{ fontSize: '14px', color: 'blue', marginRight: '18px' }} />
                                                    <Icon icon={'line-md:remove'} onClick={() => handleRemoveFields(row.id)} />

                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <Box
                            //  sx={{
                            //     position: 'fixed',
                            //     bottom: '10px',
                            //     width: '100%', 
                            //     '@media (max-width: 600px)': {
                            //       bottom: '0',
                            //       position: 'absolute',
                            //     },
                            //   }}
                            style={{ position: 'absolute', bottom: '10px', right: '20px' }}
                        >
                            <Grid container spacing={0} sx={{ mt: 1.5, }}
                            >
                                <Grid item xs={10.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>Basic Amount </Typography>
                                </Grid>
                                <Grid item xs={1.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <ERPinputNo
                                        sx={{
                                            paddingLeft: '16px',
                                            "& .MuiInputBase-root": {
                                                "& input": {
                                                    textAlign: "right",
                                                    fontSize: '12px',
                                                    color: '#000000'
                                                }
                                            }
                                        }}
                                        variant="standard"
                                        required
                                        type="number"
                                        name="basicTotal"
                                        onChange={handleChange}
                                        value={parseFloat(basicTotal).toFixed(2)}
                                        size='small'
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={10.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`}>GST Amount </Typography>
                                </Grid>
                                <Grid item xs={1.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <ERPinputNo
                                        sx={{
                                            paddingLeft: '16px',
                                            "& .MuiInputBase-root": {
                                                "& input": {
                                                    textAlign: "right",
                                                    fontSize: '12px'
                                                }
                                            }
                                        }}
                                        variant="standard"
                                        required
                                        type="number"
                                        // label="GST Total"
                                        name="gstTotal"
                                        size='small'
                                        onChange={handleChange}
                                        value={parseFloat(gstTotal).toFixed(2)}
                                        disabled={true}
                                    />
                                </Grid>
                           
                                <Grid item xs={10.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Typography className={`${styles.erp_lable}`} sx={{ textAlign: 'right' }}> Total Amount</Typography>
                                </Grid>
                                <Grid item xs={1.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <ERPinputNo
                                        sx={{
                                            paddingLeft: '16px',
                                            "& .MuiInputBase-root": {
                                                "& input": {
                                                    textAlign: "right",
                                                    fontSize: '12px'
                                                }
                                            }
                                        }}
                                        variant="standard"
                                        type="number"
                                        name="total"
                                        size='small'
                                        onChange={handleChange}
                                        value={parseFloat(total).toFixed(2)}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Typography className={`${styles.erp_lable}`} sx={{ marginBottom: '8px' }}> Remarks</Typography>
                                    <ERPinput
                                        sx={{
                                            width: { sm: 100, md: 400 },
                                            "& .MuiInputBase-root": {
                                                height: 25,
                                                fontSize: 12
                                            }
                                        }}
                                        fullWidth
                                        type="text"
                                        name="remarks"
                                        size='small'
                                        onChange={handleChange}
                                        value={(data.remarks)}
                                    />
                                </Grid>
                            </Grid>
                            <Box sx={{ marginTop: '12px', float: 'right', }}>
                                <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                    {editData ? 'Update' : 'Save'}
                                </Button>
                            </Box>
                        </Box>
                    </form>
                </Paper>

                {/* ------------- chiled Popup ---------- */}
                <Dialog onClose={handleCloseChild} open={openChild} PaperProps={{
                    sx: {
                        minWidth: "40%",
                        maxHeight: "97%",
                        minHeight: "45%"
                    }
                }}>
                    <DialogTitle style={{
                        backgroundColor: '#cfe1f7', color: '#000000', padding: '2px 2px 2px 12px', marginBottom: '14px', marginTop: '0.6px', borderTop: '1px solid #a9a9a9',
                        borderBottom: '1px solid #a9a9a9', textTransform: 'uppercase', fontSize: '15px',
                    }}>
                        {openChidOption === 'childCreate' ? 'Add Item Details' : openChidOption === 'childEdit' ? 'Update Item Details' : 'View Item Details'}
                        <CloseIcon onClick={handleCloseChild} sx={{ float: 'right', color: '#000000', cursor: 'pointer', fontSize: '24px', padding: '5px 0px 0px 0px' }} />
                    </DialogTitle>
                    {openChidOption === 'childCreate' ?
                        <>
                            <DialogContent>
                                <Grid container spacing={1.5} sx={{ p: '4px 22px 4px 22px', }}>
                                    <Grid item md={3} >
                                        <Typography className={`${styles.erp_lable}`}>Item Description</Typography>
                                    </Grid>
                                    <Grid item md={9}>
                                        <Autocomplete
                                            fullWidth
                                            classes={{
                                                option: classes.option,
                                            }}
                                            options={itemList}
                                            value={childObj.itemDescription}
                                            onChange={handleChangeItemDescription}
                                            getOptionLabel={(option) => option.itemName + ' (' + option.itemCode + ')'}
                                            getOptionSelected={(option, value) => option.id === value.id}
                                            renderInput={(params) => <ERPinput required {...params} />}
                                        />
                                    </Grid>
                                    <Grid item md={2} >
                                        <Typography className={`${styles.erp_lable}`}>HSN Code</Typography>
                                    </Grid>
                                    <Grid item md={4} >
                                        <ERPinput
                                            required
                                            type="text"
                                            name="hsnCode"
                                            value={childObj.hsnCode}
                                            size='small'
                                            onChange={handleMultipleInput}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                            sx={{ backgroundColor: '#f5fafa', }}
                                        />
                                    </Grid>
                                    <Grid item md={2} >
                                        <Typography className={`${styles.erp_lable}`}>Quantity</Typography>
                                    </Grid>
                                    <Grid item md={4} >
                                        <ERPinputNo
                                            required
                                            type="number"
                                            name="quantity"
                                            value={childObj.quantity}
                                            size='small'
                                            onChange={handleMultipleInput}
                                        />
                                    </Grid>
                                    <Grid item md={2} >
                                        <Typography className={`${styles.erp_lable}`}>Unit</Typography>
                                    </Grid>
                                    <Grid item md={4} >
                                        <ERPinput
                                            required
                                            type="text"
                                            name="unit"
                                            value={childObj.unit}
                                            size='small'
                                            onChange={handleMultipleInput}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                            sx={{ backgroundColor: '#f5fafa', }}
                                        />
                                    </Grid>
                                    <Grid item md={2} >
                                        <Typography className={`${styles.erp_lable}`}>Rate</Typography>
                                    </Grid>
                                    <Grid item md={4} >
                                        <ERPinputNo
                                            required
                                            type="number"
                                            name="rate"
                                            value={childObj.rate}
                                            size='small'
                                            onChange={handleMultipleInput}
                                        />
                                    </Grid>
                                    <Grid item md={2} >
                                        <Typography className={`${styles.erp_lable}`}>GST(%)</Typography>
                                    </Grid>
                                    <Grid item md={4} >
                                        <ERPinputNo
                                            required
                                            type="number"
                                            name="gst"
                                            value={childObj.gst}
                                            size='small'
                                            onChange={handleMultipleInput}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                            sx={{ backgroundColor: '#f5fafa', }}
                                        />
                                    </Grid>
                                    <Grid item md={2} >
                                        <Typography className={`${styles.erp_lable}`}> Amount</Typography>
                                    </Grid>
                                    <Grid item md={4} >
                                        <ERPinputNo
                                            type="number"
                                            name="amount"
                                            value={parseFloat(childObj.amount).toFixed(2)}
                                            size='small'
                                            onChange={handleMultipleInput}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            disabled={true}
                                            sx={{ backgroundColor: '#f5fafa', }}
                                        />
                                    </Grid>
                                </Grid>
                                <Box sx={{ display: 'flex', justifyContent: 'right', paddingRight: 3 }}>
                                    <Button id={`${styles.btn_save}`} variant="contained" sx={{ float: 'right', width: '145px', }}
                                        onClick={() => openChidOption === 'childCreate' ? handleOk(childObj) : handleCloseChild()} > OK </Button>
                                    <Button onClick={handleCloseChild}
                                        id={`${styles.btn_cancel}`} variant="contained" sx={{ float: 'right', width: '45px', marginRight: '9px', backgroundColor: '#d12f2f' }}> Cancel </Button>
                                </Box>
                            </DialogContent>
                        </>
                        : openChidOption === 'childEdit' ?
                            <>
                                <DialogContent>
                                    <Grid container spacing={1.5} sx={{ p: '4px 22px 4px 22px', }}>
                                        <Grid item md={3} >
                                            <Typography className={`${styles.erp_lable}`}>Item Description</Typography>
                                        </Grid>
                                        <Grid item md={9}>
                                            <Autocomplete
                                                fullWidth
                                                classes={{
                                                    option: classes.option,
                                                }}
                                                options={itemList}
                                                value={childObj.itemDescription}
                                                onChange={handleChangeItemDescription}
                                                getOptionLabel={(option) => option.itemName + ' (' + option.itemCode + ')'}
                                                getOptionSelected={(option, value) => option.itemId === value.id}
                                                renderInput={(params) => <ERPinput required {...params} />}
                                            />
                                        </Grid>
                                        <Grid item md={2} >
                                            <Typography className={`${styles.erp_lable}`}>HSN Code</Typography>
                                        </Grid>
                                        <Grid item md={4} >
                                            <ERPinput
                                                required
                                                type="text"
                                                name="hsnCode"
                                                value={childObj.hsnCode}
                                                size='small'
                                                onChange={handleMultipleInput}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                disabled={true}
                                                sx={{ backgroundColor: '#f5fafa', }}
                                            />
                                        </Grid>
                                        <Grid item md={2} >
                                            <Typography className={`${styles.erp_lable}`}>Quantity</Typography>
                                        </Grid>
                                        <Grid item md={4} >
                                            <ERPinputNo
                                                required
                                                type="number"
                                                name="quantity"
                                                value={childObj.quantity}
                                                size='small'
                                                onChange={handleMultipleInput}

                                            />
                                        </Grid>
                                        <Grid item md={2} >
                                            <Typography className={`${styles.erp_lable}`}>Unit</Typography>
                                        </Grid>
                                        <Grid item md={4} >
                                            <ERPinput
                                                required
                                                type="text"
                                                name="unit"
                                                value={childObj.unit}
                                                size='small'
                                                onChange={handleMultipleInput}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                disabled={true}
                                                sx={{ backgroundColor: '#f5fafa', }}
                                            />
                                        </Grid>
                                        <Grid item md={2} >
                                            <Typography className={`${styles.erp_lable}`}>Rate</Typography>
                                        </Grid>
                                        <Grid item md={4} >
                                            <ERPinputNo
                                                required
                                                type="number"
                                                name="rate"
                                                value={childObj.rate}
                                                size='small'
                                                onChange={handleMultipleInput}
                                            />
                                        </Grid>
                                        <Grid item md={2} >
                                            <Typography className={`${styles.erp_lable}`}>GST(%)</Typography>
                                        </Grid>
                                        <Grid item md={4} >
                                            <ERPinputNo
                                                required
                                                type="number"
                                                name="gst"
                                                value={childObj.gst}
                                                size='small'
                                                onChange={handleMultipleInput}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                disabled={true}
                                                sx={{ backgroundColor: '#f5fafa', }}
                                            />
                                        </Grid>
                                        <Grid item md={2} >
                                            <Typography className={`${styles.erp_lable}`}> Amount</Typography>
                                        </Grid>
                                        <Grid item md={4} >
                                            <ERPinputNo
                                                type="number"
                                                name="amount"
                                                value={parseFloat(childObj.amount).toFixed(2)}
                                                size='small'
                                                onChange={handleMultipleInput}
                                                InputProps={{
                                                    readOnly: true,
                                                }}
                                                disabled={true}
                                                sx={{ backgroundColor: '#f5fafa', }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Box sx={{ display: 'flex', justifyContent: 'right', paddingRight: 3 }}>
                                        <Button id={`${styles.btn_save}`} variant="contained" sx={{ float: 'right', width: '145px', }}
                                            onClick={() => openChidOption === 'childCreate' ? handleOk(childObj) : handleCloseChild()} > OK </Button>
                                        <Button onClick={handleCloseChild}
                                            id={`${styles.btn_cancel}`} variant="contained" sx={{ float: 'right', width: '45px', marginRight: '9px', backgroundColor: '#d12f2f' }}> Cancel </Button>
                                    </Box>
                                </DialogContent>
                            </>
                            :
                            <>
                                <DialogContent>
                                    <Grid container spacing={1} sx={{ mt: 0 }}>
                                        <Grid item md={4.2} style={{ paddingLeft: '25px' }}>
                                            <Typography className={`${styles.detail_lable}`}>Item Description</Typography>
                                            <Typography className={`${styles.detail_lable}`}>HSN Code</Typography>
                                            <Typography className={`${styles.detail_lable}`}>Quantity</Typography>
                                            <Typography className={`${styles.detail_lable}`}>Unit</Typography>
                                            <Typography className={`${styles.detail_lable}`}>Rate</Typography>
                                            <Typography className={`${styles.detail_lable}`}>GST (%)</Typography>
                                            <Typography className={`${styles.detail_lable}`}>Amount</Typography>
                                        </Grid>
                                        <Grid item md={0.5}>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                            <Typography className={`${styles.detail_lable}`}>: </Typography>
                                        </Grid>
                                        <Grid item md={7.3}>
                                            <Typography className={`${styles.erp_lable}`}> {childDetails.itemName + ' (' + childDetails.itemCode + ')'}</Typography>
                                            <Typography className={`${styles.erp_lable}`}> {childDetails.hsnCode}</Typography>
                                            <Typography className={`${styles.erp_lable}`}> {childDetails.quantity}</Typography>
                                            <Typography className={`${styles.erp_lable}`}> {childDetails.unit}</Typography>
                                            <Typography className={`${styles.erp_lable}`}> {childDetails.rate}</Typography>
                                            <Typography className={`${styles.erp_lable}`}> {childDetails.gst}</Typography>
                                            <Typography className={`${styles.erp_lable}`}> {childDetails.amount}</Typography>
                                        </Grid>
                                    </Grid>
                                </DialogContent></>
                    }
                </Dialog>
                {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage ? true : false}
                        autoHideDuration={2000}
                        onClose={handleCloseSuccessMsg}
                        message={successMessage}
                        action={actionMsg}
                    />
                }
            </div>
        </>
    )
}


export default PurchaseReturnAdd